
export const cofOneClick = (selectedCofType, config, finish, receive) => {
  return {
    execFunction: (error, paymentInstrument) => {
      console.log('Error/Result:', error, paymentInstrument);
      receive(error, paymentInstrument);
      finish();
    },
    visualizeFunction: () => {
      return `
function cofAgreementStateCallback(error, result) {
  console.log("cofAgreementStateCallback", error, result);

  //You need to assign the coAgreementState for future usage
  cofAgreementState = result;
}

function resultCallback(error, paymentInstrument) {
  console.log('Error/Result:', error, paymentInstrument);

  if (cofAgreementState && cofAgreementState.checked) {
    // You need to create a cof contract with the upcoming order
  }
}
    `;
    }
  };
};



// WEBPACK FOOTER //
// ./src/bridge/cof/OneClick.js